export default "__VITE_ASSET__C_h5EkWN__"